// Dynamically set the publicPath output option by using a value included
// in the server response.

if (!window._APP_) {
  throw new Error('Missing window._APP_ object');
}

// eslint-disable-next-line camelcase, no-undef
__webpack_public_path__ = window._APP_.publicPath || window._APP_PUBLIC_PATH_;
